export default __webpack_public_path__ + "static/media/03AW3AUG66.1b36ee71.jpg";